<template>
  <div class="resource-list resource-list--grid gl-grid"
       style="
      --resource-list-column-gap-desktop: 12px;
      --resource-list-row-gap-desktop: 36px;
      --resource-list-columns: repeat(6, 1fr);
      --resource-list-columns-mobile: repeat(2, 1fr);
      --column-count-mobile: 2;
    "
       data-testid="resource-list-grid">
    <div v-for="item in goodsList"
         :key="item.id"
         class="resource-list__item">
      <div class="pc-card">
        <span class="pc-link">
          <div class="pc-media">
            <img :src="item.goodsImage"
                 :alt="item.goodsName"
                 loading="lazy"
                 class="pc-img" />
          </div>
          <div class="pc-body">
            <div class="pc-title">
              {{ item.goodsName }}
            </div>
            <div class="pc-price">
              {{ item.currencySymbol || '$' }} {{ item.price }}
            </div>
          </div>
        </span>
        <span class="pc-btn"
              @click="handleBuyNow(item)">
          Buy on {{ selectPlatform.platformName }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { openPlatformBuy, reportGoodsClick } from '@/utils/goodsAction'

export default {
  name: 'GoodsList',

  props: {
    goodsList: {
      type: Array,
      default: () => []
    },

    selectPlatform: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    //立即购买
    handleBuyNow(goods) {
      reportGoodsClick(goods)
      openPlatformBuy(this.selectPlatform, goods)
    }
  }
}
</script>

<style scoped lang="scss">
/* 网格：与落地页 resource-list 变量一致，保证无主题片段时也能排版 */
.gl-grid {
  display: grid;
  grid-template-columns: var(--resource-list-columns);
  column-gap: var(--resource-list-column-gap-desktop);
  row-gap: var(--resource-list-row-gap-desktop);
  width: 100%;
  padding: 0 40px;
}

@media screen and (max-width: 749px) {
  .gl-grid {
    grid-template-columns: var(--resource-list-columns-mobile);
    padding: 0 16px;
  }
}

.pc-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--background-color);
  border: 1px solid hsl(from var(--select-color) h s l / 0.09);
  border-radius: 2px;
  overflow: hidden;
  transition:
    box-shadow 0.2s ease,
    transform 0.2s ease,
    border-color 0.2s ease;
}

.pc-card:hover {
  border-color: rgba(0, 0, 0, 0.18);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.pc-link {
  display: block;
  color: inherit;
  text-decoration: none;
}

.pc-media {
  position: relative;
  width: 100%;
  /* 统一媒体区域高度，避免同一行因素材比例不同而错位 */
  aspect-ratio: 1 / 1;
  background: #f2f2f2;
  overflow: hidden;
  display: block;
  padding: 0;
}

.pc-img {
  width: 100%;
  height: 100%;
  display: block;
  /* 统一按容器裁切，保证每行图片高度一致 */
  object-fit: cover;
  object-position: center;
  position: relative;
  z-index: 1;
}

.pc-body {
  padding: 14px 14px 10px;
}

.pc-title {
  color: var(--select-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(1.25em * 2);
}

.pc-price {
  color: var(--primary-color);
  font-size: 16px;
  font-weight: 700;
}

.pc-btn {
  margin-top: auto;
  display: block;
  text-align: center;
  background: var(--primary-color);
  color: #fff;
  text-decoration: none;
  padding: 12px 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transition: background-color 0.2s ease;
}

.pc-btn:hover {
  background: var(--primary-color);
}
</style>
